"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRewarderFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowerDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowIndex",
                type: "uint256",
            },
        ],
        name: "DistributedBorrowerPartnerToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "supplierDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "supplyIndex",
                type: "uint256",
            },
        ],
        name: "DistributedSupplierPartnerToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "PartnerTokenBorrowSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "PartnerTokenSupplySpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
        ],
        name: "SupportPartnerToken",
        type: "event",
    },
    {
        inputs: [],
        name: "DOUBLE_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allPartnerTokens",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "claimPartnerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "marketBorrowIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowBalanceStored",
                type: "uint256",
            },
        ],
        name: "distributeBorrowerPartnerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "supplierBalance",
                type: "uint256",
            },
        ],
        name: "distributeSupplierPartnerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getBorrowState",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPartnerTokenList",
        outputs: [
            {
                internalType: "address[]",
                name: "partnerTokenList",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getSupplyState",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tectonicSocketAddress",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "initializeMarketStates",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "partnerTokenInitialIndex",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "supplySpeeds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "borrowSpeeds",
                type: "uint256[]",
            },
        ],
        name: "setPartnerTokenSpeeds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_paused",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "supplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
        ],
        name: "supportPartnerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tectonicSocketAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenRewarderVersion",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "unClaimPartnerTokenAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "marketBorrowIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalBorrows",
                type: "uint256",
            },
        ],
        name: "updatePartnerTokenBorrowIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "totalSupply",
                type: "uint256",
            },
        ],
        name: "updatePartnerTokenSupplyIndex",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "partnerToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "updateTokenAccruedForUser",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class TokenRewarderFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TokenRewarderFactory = TokenRewarderFactory;
TokenRewarderFactory.bytecode = _bytecode;
TokenRewarderFactory.abi = _abi;
//# sourceMappingURL=TokenRewarderFactory.js.map